import { render } from "./Footer.vue?vue&type=template&id=c98bd476&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=c98bd476&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c98bd476"

export default script